import { PaperRollIcon } from './PaperRollIcon';

/**
 * author: Simran
 * id 1666E605-F46A-4AD2-8345-A599811B7D45
 * name paper-roll
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/paper-roll.svg
 * tags
 * - Home Automation 
 * - Printer 
 */
export const LavatoryRollIcon = PaperRollIcon;
export default LavatoryRollIcon